import { EnumAPIKey, EnumMethod } from "@/constant/app";
import { EndpointSetting } from "../../type";
import { callbackGetCategoryProducts } from "./callbacks/callbackGetCategoryProducts";
import { callbackGetDesignDetail } from "./callbacks/callbackGetDesignDetail";

export const ProductEnumEndpoints = {
  GET_PRODUCT_LIST: "/products/products/",
  GET_DESIGN: "/design/",
  GET_SHIPPING_COST: '/live-rates/',
  GET_CATEGORY_DETAIL: '/stores/store-category',
  CARETE_ORDER: '/orders/public-orders/',
  CHECK_COUPON: '/coupon-check/',
  CREATE_PAYMENT: '/payments/create',
  GET_PRODUCT_SEO: '/products/seo',
  GET_ITEMS_PRICE: '/products/price/',
  GET_PRODUCT_LIST_M: '/products/m-products'
}

export const ProductEnumEndpointsName = {
  GET_PRODUCT_LIST: "product_list",
  GET_PRODUCT_LIST_M: "product_list_m",
  GET_DESIGN: "design_detail",
  GET_PRODUCT_SEO: "product_seo",
  GET_SHIPPING_COST: 'shipping_cost',
  CREATE_ORDER: 'create_order',
  CHECK_COUPON: 'check_coupon',
  CREATE_PAYMENT: 'create_payment',
  GET_CATEGORY_DETAIL: 'category_detail',
  GET_ITEMS_PRICE: 'get_items_price'
} as const

export type TypeProductEndpointsName = typeof ProductEnumEndpointsName[keyof typeof ProductEnumEndpointsName]

export type ProductEndpoints = {
  [K in TypeProductEndpointsName]: EndpointSetting
}

export const productEndpoints: ProductEndpoints = {
  get_items_price: {
    method: EnumMethod.POST,
    endpoint: ProductEnumEndpoints.GET_ITEMS_PRICE,
    api: EnumAPIKey.API_BASE
  },
  product_list: {
    method: EnumMethod.GET,
    endpoint: ProductEnumEndpoints.GET_PRODUCT_LIST,
    api: EnumAPIKey.API_BASE,
    caller: callbackGetCategoryProducts
  },
  design_detail: {
    method: EnumMethod.GET,
    endpoint: ProductEnumEndpoints.GET_DESIGN,
    api: EnumAPIKey.API_BASE,
    caller: callbackGetDesignDetail
  },
  shipping_cost: {
    method: EnumMethod.POST,
    endpoint: ProductEnumEndpoints.GET_SHIPPING_COST,
    api: EnumAPIKey.API_BASE
  },
  create_order: {
    method: EnumMethod.POST,
    endpoint: ProductEnumEndpoints.CARETE_ORDER,
    api: EnumAPIKey.API_MAIN
  },
  check_coupon: {
    method: EnumMethod.GET,
    endpoint: ProductEnumEndpoints.CHECK_COUPON,
    api: EnumAPIKey.API_BASE
  },
  create_payment: {
    method: EnumMethod.POST,
    endpoint: ProductEnumEndpoints.CREATE_PAYMENT,
    api: EnumAPIKey.API_INTG
  },
  category_detail: {
    method: EnumMethod.GET,
    endpoint: ProductEnumEndpoints.GET_CATEGORY_DETAIL,
    api: EnumAPIKey.API_BASE
  },
  product_seo: {
    method: EnumMethod.GET,
    endpoint: ProductEnumEndpoints.GET_PRODUCT_SEO,
    api: EnumAPIKey.API_BASE
  },
  product_list_m: {
    method: EnumMethod.GET,
    endpoint: ProductEnumEndpoints.GET_PRODUCT_LIST_M,
    api: EnumAPIKey.API_BASE
  },
}